<template>
  <div>
    <Hero :isQuote="true" :image="'7'" :extension="'jpg'"></Hero>

    <section class="section">
      <div class="container" id="quote-container">
        <h1 class="title has-text-centered">{{ name }}</h1>
        <div class="before-form-text" v-if="currentStepNumber === 1">
          <p align="center">
            Please use the form below to receive a tailored quote, and note that
            <span>
              you will need your drivers license number and current insurance
              information</span
            >, if applicable.
          </p>
        </div>
        <QuoteWizard
          @completedQuote="getNewTitle"
          @updateStep="updateStepNumber"
          :currentStepNumber="currentStepNumber"
        ></QuoteWizard>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from '../components/shared/Hero';
import QuoteWizard from '../components/quote/QuoteWizard.vue';
import { canUseAdvertising } from '@/utils/tracking';

export default {
  name: 'ReceiveAQuote',
  components: {
    Hero,
    QuoteWizard
  },
  data: () => ({
    name: 'Receive a Quote',
    currentStepNumber: 0
  }),
  mounted() {
    this.FLOOD4();
  },
  methods: {
    FLOOD4() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      }
      if (!canUseAdvertising()) {
        return;
      }
      // console.log('Floodlight 4 Active');
      // USA_Porsche_DCM_Floodlight_PAI_ReceiveQuote_PageLoad
      let axel = Math.random() + '';
      let a = axel * 10000000000000;
      let flDiv = document.body.appendChild(document.createElement('div'));
      let GDPR = '${GDPR}';
      let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
      flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
      flDiv.style.position = 'absolute';
      flDiv.style.top = '0';
      flDiv.style.left = '0';
      flDiv.style.width = '1px';
      flDiv.style.height = '1px';
      flDiv.style.display = 'none';
      flDiv.innerHTML = `<iframe id=${process.env.VUE_APP_FLOODLIGHT_ID +
        '_FLIframe2'} src="https://5368208.fls.doubleclick.net/activityi;src=5368208;type=porsc00c;cat=usa_p00;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=${a}?" width="1" height="1" frameborder="0"></iframe>`;
    },
    getNewTitle(title) {
      this.name = title;
    },
    updateStepNumber(newStepNumber) {
      this.currentStepNumber = newStepNumber;
    }
  }
};
</script>
<style lang="scss" scoped>
.before-form-text {
  margin: 3.5rem;
  padding: 0 1rem;
  @media screen and (max-width: 480px) {
    margin: 2.5rem 0.5rem;
  }
  @media screen and (min-width: 992px) {
    padding: 0 7rem;
  }
  @media screen and (min-width: 1200px) {
    padding: 0 16rem;
  }
  @media screen and (min-width: 1400px) {
    padding: 0 18rem;
  }
  @media screen and (min-width: 1920px) {
    padding: 0 28rem;
  }
  p {
    -ms-word-break: break-word;
    word-break: break-word;

    /* Non standard for WebKit */
    word-break: break-word;

    -webkit-hyphens: none;
    -moz-hyphens: none;
    hyphens: none;
  }
  p span {
    color: $primary;
  }
}
</style>
